import React from 'react';
import { FiAward, FiClock, FiMapPin, FiGlobe } from 'react-icons/fi';

const BenefitsStrip = () => {
  const benefits = [
    {
      icon: FiAward,
      title: "Maryland Commissioned",
      desc: "State notary commission valid through 2030."
    },
    {
      icon: FiClock,
      title: "Evenings and Weekends",
      desc: "Booked around your real schedule."
    },
    {
      icon: FiMapPin,
      title: "We Come to You",
      desc: "Home, office, hospital, or wherever works."
    },
    {
      icon: FiGlobe,
      title: "English and Português",
      desc: "Every step explained in your language."
    }
  ];

  return (
    <section className="bg-navy py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {benefits.map((benefit, i) => (
          <div key={i} className="flex items-center gap-4 text-cream">
            <div className="w-10 h-10 rounded-full border border-brass flex items-center justify-center text-brass shrink-0">
              <benefit.icon size={20} />
            </div>
            <div>
              <h3 className="font-bold text-sm tracking-wide mb-1">{benefit.title}</h3>
              <p className="text-xs text-cream/60 leading-tight">{benefit.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitsStrip;